const jacksonproduct = [

  {
    id: 1,
    brand: "Bolson",
    title: "Bolson Sofa",
    price: "1,056,000원 ~",
    img_url: "/defaultimages/Bolson_Sofa_Fabric.png",
    img_hover: "/hoverimages/Bolson_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa",
    sale: "20%",
    price_regular: "2,300,000원"
  },
  {
    id: 2,
    brand: "Dough",
    title: "Dough Sofa",
    price: "1,903,000원 ~",
    img_url: "/defaultimages/Dough_Sofa_Leather.png",
    img_hover: "/hoverimages/Dough_Sofa_Leather_hover.jpg",
    date: "202504",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 3,
    brand: "Ink",
    title: "Ink Sofa",
    price: "2,068,000원 ~",
    img_url: "/defaultimages/Ink_Sofa_Fabric.png",
    img_hover: "/hoverimages/Ink_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 4,
    brand: "Pebble",
    title: "Pebble Sofa",
    price: "1,419,000원 ~",
    img_url: "/defaultimages/Pebble_Sofa_Fabric.png",
    img_hover: "/hoverimages/Pebble_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 5,
    brand: "Tarte",
    title: "Tarte Sofa",
    price: "2,695,000원 ~",
    img_url: "/defaultimages/Tarte_Sofa_Leather.png",
    img_hover: "/hoverimages/Tarte_Sofa_Leather_hover.jpg",
    date: "202504",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 6,
    brand: "Pillow",
    title: "Pillow Sofa",
    price: "995,000원 ~",
    img_url: "/defaultimages/Pillow_Sofa_Fabric.png",
    img_hover: "/hoverimages/Pillow_Sofa_Fabric_hover.jpg",
    date: "202410",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 7,
    brand: "Petalo",
    title: "Petalo Chair",
    price: "330,000원",
    img_url: "/defaultimages/Petalo_Chair_Dining.png",
    img_hover: "/hoverimages/Petalo_Chair_Dining_hover.jpg",
    date: "202411",
    subcate: "Dining",
    product: "chair"
  },
  {
    id: 8,
    brand: "Shelter",
    title: "Shelter Dining Chair",
    price: "495,000원",
    img_url: "/defaultimages/Shelter_Chair_Dining.png",
    img_hover: "/hoverimages/Shelter_Chair_Dining_hover.jpg",
    date: "202410",
    subcate: "Dining",
    product: "chair"
  },
  {
    id: 9,
    brand: "Round",
    title: "Round Arm Chair",
    price: "407,000원",
    img_url: "/defaultimages/RoundArm_Chair_Dining.png",
    img_hover: "/hoverimages/RoundArm_Chair_Dining_hover.jpg",
    date: "202212",
    subcate: "Dining",
    product: "chair"
  },
  {
    id: 10,
    brand: "Round",
    title: "Round Dining Chair",
    price: "374,000원 ~",
    img_url: "/defaultimages/Round_Chair_Dining.png",
    img_hover: "/hoverimages/Round_Chair_Dining_hover.jpg",
    date: "202212",
    subcate: "Dining",
    product: "chair"
  },


  {
    id: 11,
    brand: "Round B",
    title: "Round B Dining Chair",
    price: "407,000원",
    img_url: "/defaultimages/RoundB__Chair_Dining.png",
    img_hover: "/hoverimages/RoundB__Chair_Dining_hover.jpg",
    date: "202204",
    subcate: "Dining",
    product: "chair"
  },
  {
    id: 12,
    brand: "Tilt",
    title: "Tilt Chair",
    price: "396,000원",
    img_url: "/defaultimages/Tilt_Chair_Dining.png",
    img_hover: "/hoverimages/Tilt_Chair_Dining_hover.jpg",
    date: "202205",
    subcate: "Dining",
    product: "chair"
  },
    {
    id: 13,
    brand: "Pesca",
    title: "Pesca Sofa",
    price: "2,380,000원 ~",
    img_url: "/defaultimages/Pesca_Sofa_Fabric.png",
    img_hover: "/hoverimages/Pesca_Sofa_Fabric_hover.jpg",
    date: "202409",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 14,
    brand: "Flare",
    title: "Flare Table",
    price: "2,937,000원",
    img_url: "/defaultimages/Flare_Table_Dining.png",
    img_hover: "/hoverimages/Flare_Table_Dining_hover.jpg",
    date: "202510",
    subcate: "Side",
    product: "table",
    badges: "New"
  },
  {
    id: 15,
    brand: "Plato",
    title: "Plato Round Table",
    price: "1,122,000원",
    img_url: "/defaultimages/PlatoRound_Table_Dining.png",
    img_hover: "/hoverimages/PlatoRound_Table_Dining_hover.jpg",
    date: "202401",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 16,
    brand: "Plato",
    title: "Plato Oval Table",
    price: "1,463,000원",
    img_url: "/defaultimages/PlatoOval_Table_Dining.png",
    img_hover: "/hoverimages/PlatoOval_Table_Dining_hover.jpg",
    date: "202401",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 17,
    brand: "Pillar",
    title: "Pillar Oval Table",
    price: "3,421,000원",
    img_url: "/defaultimages/PillarOval_Table_Dining.png",
    img_hover: "/hoverimages/PillarOval_Table_Dining_hover.jpg",
    date: "202508",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 18,
    brand: "Blank",
    title: "Blank Table",
    price: "1,892,000원 ~",
    img_url: "/defaultimages/Blank_Table_Dining.png",
    img_hover: "/hoverimages/Blank_Table_Dining_hover.jpg",
    date: "202205",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 19,
    brand: "Duro",
    title: "Duro Round Table",
    price: "561,000원 ~",
    img_url: "/defaultimages/DuroRound_Table_Dining.png",
    img_hover: "hoverimages/DuroRound_Table_Dining_hover.jpg",
    date: "202103",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 20,
    brand: "Duro",
    title: "Duro Square Table",
    price: "737,000원 ~",
    img_url: "/defaultimages/DuroSquare_Table_Dining.png",
    img_hover: "hoverimages/DuroSquare_Table_Dining_hover.jpg",
    date: "202103",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 21,
    brand: "Tartan",
    title: "Tartan Sofa",
    price: "1,551,000원 ~",
    img_url: "/defaultimages/Tartan_Sofa_Fabric.png",
    img_hover: "/hoverimages/Tartan_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 22,
    brand: "Note",
    title: "Note Dining Chair (Colour Edition)",
    price: "385,000원",
    img_url: "/defaultimages/Note_Chair_Dining.png",
    img_hover: "/hoverimages/Note_Chair_Dining_hover.jpg",
    date: "202508",
    subcate: "Dining",
    product: "chair"
  },
  {
    id: 23,
    brand: "Ink",
    title: "Ink Module",
    price: "660,000원 ~",
    img_url: "/defaultimages/InkModule_Sofa_Fabric.png",
    img_hover: "/hoverimages/InkModule_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 24,
    brand: "Note",
    title: "Note Dining Chair",
    price: "385,000원",
    img_url: "/defaultimages/Note_Chair_Dining.png",
    img_hover: "/hoverimages/Note_Chair_Dining_hover.jpg",
    date: "202412",
    subcate: "Dining",
    product: "chair"
  },
  {
    id: 25,
    brand: "Pebble",
    title: "Pebble Module",
    price: "286,000원 ~",
    img_url: "/defaultimages/PebbleModule_Sofa_Fabric.png",
    img_hover: "/hoverimages/PebbleModule_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 26,
    brand: "Tumo",
    title: "Tumo Sofa",
    price: "2,288,000원 ~",
    img_url: "/defaultimages/Tumo_Sofa_Fabric.png",
    img_hover: "/hoverimages/Tumo_Sofa_Fabric_hover.jpg",
    date: "202509",
    subcate: "Fabric",
    product: "sofa",
    badges: "New"
  },
  {
    id: 27,
    brand: "Otium",
    title: "Otium Daybed Sofa",
    price: "2,002,000원 ~",
    img_url: "/defaultimages/OtiumDaybed_Sofa_Fabric.png",
    img_hover: "/hoverimages/OtiumDaybed_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 28,
    brand: "Bumpy",
    title: "Bumpy Sofa",
    price: "1,309,000원 ~",
    img_url: "/defaultimages/Bumpy_Sofa_Fabric.png",
    img_hover: "/hoverimages/Bumpy_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 29,
    brand: "Tarte",
    title: "Tarte Sofa",
    price: "1,606,000원 ~",
    img_url: "/defaultimages/Tarte_Sofa_Fabric.png",
    img_hover: "/hoverimages/Tarte_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 30,
    brand: "Duro",
    title: "Duro Round Dining Table",
    price: "1,276,000원",
    img_url: "/defaultimages/DuroRound_Table_Dining.png",
    img_hover: "/hoverimages/DuroRound_Table_Dining_hover.jpg",
    date: "202303",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 31,
    brand: "Round",
    title: "Round Bench",
    price: "407,000원",
    img_url: "/defaultimages/Round_Bench_Bench.png",
    img_hover: "/hoverimages/Round_Bench_Bench_hover.jpg",
    date: "202212",
    subcate: "Bench",
    product: "chair"
  },
  {
    id: 32,
    brand: "Flare",
    title: "Flare Dining Table",
    price: "1,562,000원 ~",
    img_url: "/defaultimages/Flare_Table_Dining.png",
    img_hover: "/hoverimages/Flare_Table_Dining_hover.jpg",
    date: "202303",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 33,
    brand: "Flare",
    title: "Flare Gloss Dining Table",
    price: "1,892,000원",
    img_url: "/defaultimages/FlareGloss_Table_Dining.png",
    img_hover: "/hoverimages/FlareGloss_Table_Dining_hover.jpg",
    date: "202401",
    subcate: "Dining",
    product: "table"
  },
  {
    id: 34,
    brand: "Dough",
    title: "Dough Sofa",
    price: "1,782,000원 ~",
    img_url: "/defaultimages/Dough_Sofa_Fabric.png",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 35,
    brand: "Mass",
    title: "Mass Sofa",
    price: "1,331,000원 ~",
    img_url: "/defaultimages/Mass_Sofa_Fabric.png",
    img_hover: "/hoverimages/Mass_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 36,
    brand: "Divine",
    title: "Divine Sofa",
    price: "1,848,000원 ~",
    img_url: "/defaultimages/Divine_Sofa_Fabric.png",
    img_hover: "/hoverimages/Divine_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 37,
    brand: "Clay",
    title: "Clay Sofa",
    price: "2,772,000원 ~",
    img_url: "/defaultimages/Clay_Sofa_Fabric.png",
    img_hover: "/hoverimages/Clay_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 38,
    brand: "Clay",
    title: "Clay Module",
    price: "561,000원 ~",
    img_url: "/defaultimages/ClayModule_Sofa_Fabric.png",
    img_hover: "/hoverimages/ClayModule_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 39,
    brand: "Slash",
    title: "Slash Sofa",
    price: "429,000원 ~",
    img_url: "/defaultimages/Slash_Sofa_Fabric.png",
    img_hover: "/hoverimages/Slash_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 40,
    brand: "Bowl",
    title: "Bowl Sofa",
    price: "1,474,000원 ~",
    img_url: "/defaultimages/Bowl_Sofa_Fabric.png",
    img_hover: "/hoverimages/Bowl_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa",
    badge: "new"
  },
  {
    id: 41,
    brand: "Bowl",
    title: "Bowl Module",
    price: "374,000원 ~",
    img_url: "/defaultimages/BowlModule_Sofa_Fabric.png",
    img_hover: "/hoverimages/BowlModule_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa",
    badge: "new"
  },
  {
    id: 42,
    brand: "Garden",
    title: "Garden Sofa",
    price: "2,046,000원 ~",
    img_url: "/defaultimages/Garden_Sofa_Fabric.png",
    img_hover: "/hoverimages/Garden_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 43,
    brand: "Dimple",
    title: "Dimple Sofa",
    price: "1,771,000원 ~",
    img_url: "/defaultimages/Dimple_Sofa_Fabric.png",
    img_hover: "/hoverimages/Dimple_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 44,
    brand: "Slash",
    title: "Slash Sofa",
    price: "1,441,000원 ~",
    img_url: "/defaultimages/Slash_Sofa_Fabric.png",
    img_hover: "/hoverimages/Slash_Sofa_Fabric_hover.jpg",
    date: "202407",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 45,
    brand: "Montar",
    title: "Montar Sofa",
    price: "3,960,000원 ~",
    img_url: "/defaultimages/Montar_Sofa_Fabric.png",
    img_hover: "/hoverimages/Montar_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 46,
    brand: "Pillow",
    title: "Pillow Sofa",
    price: "2,046,000원 ~",
    img_url: "/defaultimages/Pillow_Sofa_Fabric.png",
    img_hover: "/hoverimages/Pillow_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 47,
    brand: "Pepe",
    title: "Pepe Sofa",
    price: "2,046,000원",
    img_url: "/defaultimages/Pepe_Sofa_Fabric.png",
    img_hover: "/hoverimages/Pepe_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 48,
    brand: "Pesca",
    title: "Pesca Sofa",
    price: "1,474,000원 ~",
    img_url: "/defaultimages/Pesca_Sofa_Fabric.png",
    img_hover: "/hoverimages/Pesca_Sofa_Fabric_hover.jpg",
    date: "202504",
    subcate: "Fabric",
    product: "sofa"
  },
  // {
  //   id: 49,
  //   brand: "Fabric",
  //   title: "Fabric Free Sample",
  //   price: "무료",
  //   img_url: "/defaultimages/Fabric_FreeSample.png",
  //   img_hover: "/hoverimages/Fabric_FreeSample_hover.jpg",
  //   date: "202311",
  //   subcate: "Fabric",
  //   product: "sofa"
  // },
  {
    id: 50,
    brand: "Cone",
    title: "Cone Lamp (Colour Edition)",
    price: "297,000원 ~",
    img_url: "/defaultimages/Cone_Lamp_Floor.png",
    img_hover: "/hoverimages/Cone_Lamp_Floor_hover.jpg",
    date: "202509",
    subcate: "Floor Lamp",
    product: "lighting",
    badges: "New"
  },
  {
    id: 51,
    brand: "Pin",
    title: "Pin Floor Lamp",
    price: "616,000원",
    img_url: "/defaultimages/Pin_Lamp_Floor.png",
    img_hover: "/hoverimages/Pin_Lamp_Floor_hover.jpg",
    date: "202208",
    subcate: "Floor Lamp",
    product: "lighting"
  },
  {
    id: 52,
    brand: "Cone",
    title: "Cone Floor Lamp",
    price: "550,000원 ~",
    img_url: "/defaultimages/Cone_Lamp_Table.png",
    img_hover: "/hoverimages/Cone_Lamp_Table_hover.jpg",
    date: "202207",
    subcate: "Floor Lamp",
    product: "lighting"
  },
  {
    id: 53,
    brand: "Scoop",
    title: "Scoop Floor Lamp",
    price: "429,000원",
    img_url: "/defaultimages/Scoop_Lamp_Floor.png",
    img_hover: "/hoverimages/Scoop_Lamp_Floor_hover.jpg",
    date: "202401",
    subcate: "Floor Lamp",
    product: "lighting"
  },
  {
    id: 54,
    brand: "Donut",
    title: "Donut Floor Lamp",
    price: "374,000원",
    img_url: "/defaultimages/Donut_Lamp_Floor.png",
    img_hover: "/hoverimages/Donut_Lamp_Floor_hover.jpg",
    date: "202311",
    subcate: "Floor Lamp",
    product: "lighting"
  },
  {
    id: 55,
    brand: "Tartan",
    title: "Tartan Sofa",
    price: "2,112,000원 ~",
    img_url: "/defaultimages/Tartan Sofa - Leather.png",
    img_hover: "/hoverimages/Tartan Sofa - Leather_hover.jpg",
    date: "202508",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 56,
    brand: "Pebble",
    title: "Pebble Sofa",
    price: "3,069,000원 ~",
    img_url: "/defaultimages/Pebble_Sofa_Leather.png",
    img_hover: "/hoverimages/Pebble_Sofa_Leather_hover.jpg",
    date: "202504",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 57,
    brand: "Pebble",
    title: "Pebble Module",
    price: "638,000원 ~",
    img_url: "/defaultimages/PebbleModule_Sofa_Leather.png",
    img_hover: "/hoverimages/PebbleModule_Sofa_Leather_hover.jpg",
    date: "202504",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 58,
    brand: "Tumo",
    title: "Tumo Sofa",
    price: "3,355,000원 ~",
    img_url: "/defaultimages/Tumo_Sofa_Leather.png",
    img_hover: "/hoverimages/Tumo_Sofa_Leather_hover.jpg",
    date: "202509",
    subcate: "Leather",
    product: "sofa",
    badges: "New"
  },
  {
    id: 59,
    brand: "Tartan",
    title: "Tartan Sofa",
    price: "2,002,000원~",
    img_url: "/defaultimages/Tartan Sofa - Leather.png",
    img_hover: "/hoverimages/Tartan Sofa - Leather_hover.jpg",
    date: "202504",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 60,
    brand: "Non",
    title: "Non ArmChair",
    price: "484,000원",
    img_url: "/defaultimages/NonArm_Chair_Dining.png",
    img_hover: "/hoverimages/NonArm_Chair_Dining_hover.jpg",
    date: "202412",
    subcate: "Dining",
    product: "chair"
  },
  {
    id: 61,
    brand: "Plume",
    title: "Plume Sofa",
    price: "1,848,000원 ~",
    img_url: "/defaultimages/Plume_SofaLeather.png",
    img_hover: "/hoverimages/Plume_SofaLeather_hover.jpg",
    date: "202505",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 62,
    brand: "Plume",
    title: "Plume Sofa",
    price: "1,716,000원 ~",
    img_url: "/defaultimages/Plume_Sofa_Fabric.png",
    img_hover: "/hoverimages/Plume_Sofa_Fabric_hover.jpg",
    date: "202505",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 63,
    brand: "Botany",
    title: "Botany Dining Chair",
    price: "385,000원 ~",
    img_url: "/defaultimages/Botany_Chair_Dining.png",
    img_hover: "/hoverimages/Botany_Chair_Dining_hover.jpg",
    date: "202507",
    subcate: "Dining",
    product: "chair"
  },
  {
    id: 64,
    brand: "Tumo",
    title: "Tumo Sofa",
    price: "2,574,000원 ~",
    img_url: "/defaultimages/Tumo_Sofa_Fabric.png",
    img_hover: "/hoverimages/Tumo_Sofa_Fabric_hover.jpg",
    date: "202509",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 65,
    brand: "Tumo",
    title: "Tumo Sofa",
    price: "3,355,000원 ~",
    img_url: "/defaultimages/Tumo_Sofa_Leather.png",
    img_hover: "/hoverimages/Tumo_Sofa_Leather_hover.jpg",
    date: "202509",
    subcate: "Leather",
    product: "sofa",
    badges: "New"
  },
  {
    id: 66,
    brand: "Clay",
    title: "Clay Module",
    price: "1,056,000원 ~",
    img_url: "/defaultimages/ClayModule_Sofa_Leather.png",
    img_hover: "/hoverimages/ClayModule_Sofa_Leather_hover.jpg",
    date: "202504",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 67,
    brand: "Ink",
    title: "Ink Lounge Chair",
    price: "990,000원 ~",
    img_url: "/defaultimages/Ink_Chair_Lounge.png",
    img_hover: "/hoverimages/Ink_Chair_Lounge_hover.jpg",
    date: "202507",
    subcate: "Lounge",
    product: "chair"
  },
  {
    id: 68,
    brand: "Botany",
    title: "Botany Lounge Chair",
    price: "594,000원 ~",
    img_url: "/defaultimages/Botany_Chair_Lounge.png",
    img_hover: "/hoverimages/Botany_Chair_Lounge_hover.jpg",
    date: "202507",
    subcate: "Lounge",
    product: "chair"
  },
  {
    id: 69,
    brand: "Tilt E",
    title: "Tilt E Lounge Chair",
    price: "990,000원",
    img_url: "/defaultimages/Tilt_Chair_Lounge.png",
    img_hover: "/hoverimages/Tilt_Chair_Lounge_hover.jpg",
    date: "202310",
    subcate: "Lounge",
    product: "chair"
  },
  {
    id: 70,
    brand: "Shelter",
    title: "Shelter Lounge Chair",
    price: "660,000원",
    img_url: "/defaultimages/Shelter_Chair_Lounge.png",
    img_hover: "/hoverimages/Shelter_Chair_Lounge_hover.jpg",
    date: "202410",
    subcate: "Lounge",
    product: "chair"
  },
  {
    id: 71,
    brand: "Non",
    title: "Non Lounge Chair",
    price: "693,000원",
    img_url: "/defaultimages/Non_Chair_Lounge.png",
    img_hover: "/hoverimages/Non_Chair_Lounge_hover.jpg",
    date: "202412",
    subcate: "Lounge",
    product: "chair"
  },
  {
    id: 72,
    brand: "Round B",
    title: "Round B Lounge Chair",
    price: "495,000원",
    img_url: "/defaultimages/Round_Chair_Lounge.png",
    img_hover: "/hoverimages/Round_Chair_Lounge_hover.jpg",
    date: "202204",
    subcate: "Lounge",
    product: "chair"
  },
  {
    id: 73,
    brand: "Note",
    title: "Note Lounge Chair",
    price: "473,000원",
    img_url: "/defaultimages/Note_Chair_Lounge.png",
    img_hover: "/hoverimages/Note_Chair_Lounge_hover.jpg",
    date: "202412",
    subcate: "Lounge",
    product: "chair"
  },
  {
    id: 74,
    brand: "Addo",
    title: "Addo Stool (Colour Edition)",
    price: "385,000원",
    img_url: "/defaultimages/AddoStool_Chair_Lounge.png",
    img_hover: "/hoverimages/AddoStool_Chair_Lounge_hover.jpg",
    date: "202507",
    subcate: "Lounge",
    product: "chair"
  },
  {
    id: 75,
    brand: "Cone",
    title: "Cone Lamp Floor",
    price: "396,000원",
    img_url: "/defaultimages/Cone_Lamp_Floor.png",
    img_hover: "/hoverimages/Cone_Lamp_Floor_hover.jpg",
    date: "202311",
    subcate: "lamp",
    product: "lighting"
  },
  {
    id: 76,
    brand: "Cone",
    title: "Cone Lamp Table",
    price: "330,000원",
    img_url: "/defaultimages/Cone_Lamp_Table.png",
    img_hover: "/hoverimages/Cone_Lamp_Table_hover.jpg",
    date: "202311",
    subcate: "lamp",
    product: "lighting"
  },
  {
    id: 77,
    brand: "Donut",
    title: "Donut Lamp Floor",
    price: "440,000원",
    img_url: "/defaultimages/Donut_Lamp_Floor.png",
    img_hover: "/hoverimages/Donut_Lamp_Floor_hover.jpg",
    date: "202311",
    subcate: "lamp",
    product: "lighting"
  },
  {
    id: 78,
    brand: "Layer",
    title: "Layer Lamp Table",
    price: "297,000원",
    img_url: "/defaultimages/Layer_Lamp_Table.png",
    img_hover: "/hoverimages/Layer_Lamp_Table_hover.jpg",
    date: "202311",
    subcate: "lamp",
    product: "lighting"
  },
  {
    id: 79,
    brand: "Pin",
    title: "Pin Lamp Floor",
    price: "330,000원",
    img_url: "/defaultimages/Pin_Lamp_Floor.png",
    img_hover: "/hoverimages/Pin_Lamp_Floor_hover.jpg",
    date: "202311",
    subcate: "lamp",
    product: "lighting"
  },
  {
    id: 80,
    brand: "Pin",
    title: "Pin Lamp Table",
    price: "275,000원",
    img_url: "/defaultimages/Pin_Lamp_Table.png",
    img_hover: "/hoverimages/Pin_Lamp_Table_hover.jpg",
    date: "202311",
    subcate: "lamp",
    product: "lighting"
  },
  {
    id: 81,
    brand: "Scoop",
    title: "Scoop Lamp Floor",
    price: "352,000원",
    img_url: "/defaultimages/Scoop_Lamp_Floor.png",
    img_hover: "/hoverimages/Scoop_Lamp_Floor_hover.jpg",
    date: "202311",
    subcate: "lamp",
    product: "lighting"
  },
  {
    id: 82,
    brand: "Scoop",
    title: "Scoop Lamp Table",
    price: "297,000원",
    img_url: "/defaultimages/Scoop_Lamp_Table.png",
    img_hover: "/hoverimages/Scoop_Lamp_Table_hover.jpg",
    date: "202311",
    subcate: "lamp",
    product: "lighting"
  },
  {
    id: 83,
    brand: "Bao",
    title: "Bao Sofa",
    price: "1,680,000원 ~",
    img_url: "/defaultimages/Bao_Sofa_Fabric.png",
    img_hover: "/hoverimages/Bao_Sofa_Fabric_hover.jpg",
    date: "202401",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 84,
    brand: "Bolson",
    title: "Bolson Sofa",
    price: "1,056,000원 ~",
    img_url: "/defaultimages/Bolson_Sofa_Fabric.png",
    img_hover: "/hoverimages/Bolson_Sofa_Fabric_hover.jpg",
    date: "202402",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 85,
    brand: "Bowl",
    title: "Bowl Sofa",
    price: "1,980,000원 ~",
    img_url: "/defaultimages/Bowl_Sofa_Fabric.png",
    img_hover: "/hoverimages/Bowl_Sofa_Fabric_hover.jpg",
    date: "202403",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 86,
    brand: "Bowl",
    title: "Bowl Module Sofa",
    price: "1,480,000원 ~",
    img_url: "/defaultimages/BowlModule_Sofa_Fabric.png",
    img_hover: "/hoverimages/BowlModule_Sofa_Fabric_hover.jpg",
    date: "202403",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 87,
    brand: "Bumpy",
    title: "Bumpy Sofa",
    price: "1,980,000원 ~",
    img_url: "/defaultimages/Bumpy_Sofa_Fabric.png",
    img_hover: "/hoverimages/Bumpy_Sofa_Fabric_hover.jpg",
    date: "202404",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 88,
    brand: "Clay",
    title: "Clay Sofa (Fabric)",
    price: "2,480,000원 ~",
    img_url: "/defaultimages/Clay_Sofa_Fabric.png",
    img_hover: "/hoverimages/Clay_Sofa_Fabric_hover.jpg",
    date: "202405",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 89,
    brand: "Clay",
    title: "Clay Sofa (Leather)",
    price: "3,120,000원 ~",
    img_url: "/defaultimages/Clay_Sofa_Leather.png",
    img_hover: "/hoverimages/Clay_Sofa_Leather_hover.jpg",
    date: "202405",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 90,
    brand: "Clay",
    title: "Clay Module Sofa (Fabric)",
    price: "1,380,000원 ~",
    img_url: "/defaultimages/ClayModule_Sofa_Fabric.png",
    img_hover: "/hoverimages/ClayModule_Sofa_Fabric_hover.jpg",
    date: "202405",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 91,
    brand: "Clay",
    title: "Clay Module Sofa (Leather)",
    price: "1,980,000원 ~",
    img_url: "/defaultimages/ClayModule_Sofa_Leather.png",
    img_hover: "/hoverimages/ClayModule_Sofa_Leather_hover.jpg",
    date: "202405",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 92,
    brand: "Dimple",
    title: "Dimple Sofa",
    price: "1,580,000원 ~",
    img_url: "/defaultimages/Dimple_Sofa_Fabric.png",
    img_hover: "/hoverimages/Dimple_Sofa_Fabric_hover.jpg",
    date: "202406",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 93,
    brand: "Mass",
    title: "Mass Sofa",
    price: "1,780,000원 ~",
    img_url: "/defaultimages/Mass_Sofa_Fabric.png",
    img_hover: "/hoverimages/Mass_Sofa_Fabric_hover.jpg",
    date: "202406",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 94,
    brand: "Montar",
    title: "Montar Sofa",
    price: "2,480,000원 ~",
    img_url: "/defaultimages/Montar_Sofa_Fabric.png",
    img_hover: "/hoverimages/Montar_Sofa_Fabric_hover.jpg",
    date: "202407",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 95,
    brand: "Otium",
    title: "Otium Daybed Sofa (Fabric)",
    price: "2,180,000원 ~",
    img_url: "/defaultimages/OtiumDaybed_Sofa_Fabric.png",
    img_hover: "/hoverimages/OtiumDaybed_Sofa_Fabric_hover.jpg",
    date: "202407",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 96,
    brand: "Otium",
    title: "Otium Daybed Sofa (Leather)",
    price: "2,980,000원 ~",
    img_url: "/defaultimages/OtiumDaybed_Sofa_Leather.png",
    img_hover: "/hoverimages/OtiumDaybed_Sofa_Leather_hover.jpg",
    date: "202407",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 97,
    brand: "Pebble",
    title: "Pebble Sofa (Fabric)",
    price: "1,580,000원 ~",
    img_url: "/defaultimages/Pebble_Sofa_Fabric.png",
    img_hover: "/hoverimages/Pebble_Sofa_Fabric_hover.jpg",
    date: "202408",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 98,
    brand: "Pebble",
    title: "Pebble Sofa (Leather)",
    price: "2,280,000원 ~",
    img_url: "/defaultimages/Pebble_Sofa_Leather.png",
    img_hover: "/hoverimages/Pebble_Sofa_Leather_hover.jpg",
    date: "202408",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 99,
    brand: "Pebble",
    title: "Pebble Module Sofa (Fabric)",
    price: "1,980,000원 ~",
    img_url: "/defaultimages/PebbleModule_Sofa_Fabric.png",
    img_hover: "/hoverimages/PebbleModule_Sofa_Fabric_hover.jpg",
    date: "202408",
    subcate: "Fabric",
    product: "sofa"
  },
  {
    id: 100,
    brand: "Pebble",
    title: "Pebble Module Sofa (Leather)",
    price: "2,680,000원 ~",
    img_url: "/defaultimages/PebbleModule_Sofa_Leather.png",
    img_hover: "/hoverimages/PebbleModule_Sofa_Leather_hover.jpg",
    date: "202408",
    subcate: "Leather",
    product: "sofa"
  },
  {
    id: 101,
    brand: "Pepe",
    title: "Pepe Sofa",
    price: "1,480,000원 ~",
    img_url: "/defaultimages/Pepe_Sofa_Fabric.png",
    img_hover: "/hoverimages/Pepe_Sofa_Fabric_hover.jpg",
    date: "202409",
    subcate: "Fabric",
    product: "sofa"
  },



];


export default jacksonproduct;